<template>
    <f-form sticky-action class="stripe-order-invoices">
        <template #title>
            <f-icon icon="fa6-credit-card"></f-icon> {{ $vt('Invoices') }}
        </template>
        <template #content>
            <div class="orders f-sexy-scroll">
                <div class="orders-header order-subgrid">
                    <div class="date">{{ $vt('Date') }}</div>
                    <div class="description">{{ $vt('Description') }}</div>
                    <div class="cost">{{ $vt('Cost') }}</div>
                    <div class="invoice">{{ $vt('Invoice') }}</div>
                </div>
                <StripeOrderInvoicesItems v-for="order in component.orders" :order="order" :key="order.id" />
            </div>
        </template>
    </f-form>
</template>
<script>

import { stripePriceToString } from '~/stripe.utils.mjs'

import StripeOrderInvoicesItems from './StripeOrderInvoicesItems.vue'

export default {
    components: {
        StripeOrderInvoicesItems
    },
    props: {
        component: {
            type: Object,
            required: true
        },
        handler: {
            type: Object,
            required: true
        }
    },
    translate25Context: 'stripe.orders',
    methods: {
        getInvoiceData(order, key) {
            const value = order?.data?.[key] ?? `missing ${key}`
            return value
        },
        getInvoiceDataPrice(order, key) {
            const data = order?.data?.[key]
            if (data === undefined) {
                return `missing ${key}`
            }
            return stripePriceToString(data)
        }
    },
    mounted() {

    }
}
</script>

<style lang="scss">
.stripe-order-invoices-ng {
    width: 100%;
    height: 100%;
    > * {
        height: 100%;
    }
}

.stripe-order-invoices {
    position: relative;

    .content-container>.content {
        max-height: 100%;
    }

    .orders {

        // padding: 16px 8px;
        padding-right: 16px;
        display: grid;
        grid-template-columns: repeat(4, auto);

        align-items: start;
        align-content: flex-start;


        max-height: 100%;
        overflow: auto;

        position: relative;

        .order-subgrid {
            grid-column: 1 / -1;
            display: grid;
            grid-template-columns: subgrid;

            height: 42px;

            > :nth-child(4) {
                justify-self: right;
            }
        }

        .orders-header {

            position: sticky;
            top: 0;
            background: linear-gradient(180deg, var(--black) 0%, var(--black) 80%, var(--black-a0) 100%);
            z-index: 5;

            color: var(--white-75, rgba(255, 255, 255, 0.75));
            /* Navigation/Item/Font-size 100/Highlight */
            font-family: Lato;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
    }

    .f-button {
        padding: 0;
    }
}
</style>